import { IParamsRequest } from 'redhotpie-shared-lib/interfaces/IAction';
import { IApiResponse } from 'redhotpie-shared-lib/interfaces/IApiResponse';
import memberSearchApi from '../api/memberSearchApi';
import memberProfile from '../models/memberProfile';
import memberSearch from '../models/memberSearch';
import nicheSearch from '../models/niceSearch';
import properyItemModel from '../models/properyItem';
import SavedSearches from '../models/savedSearches';
import userStatus from '../models/userStatus';
import * as myStore from '../store/myStore';
import MemberSearch from '../models/memberSearch';
import { IMemberProfile } from 'redhotpie-shared-lib/interfaces/IUser';

class MemberSearchService {
  getUserSearchSettings(): Promise<IApiResponse<MemberSearch>> {
    return memberSearchApi.getUserSearchSettings().then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: memberSearch.mappingUserSearchSettings(res.data),
          };
        }
        console.log('ERROR: memberSearchService/getUserSearchSettings:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: memberSearchService/getUserSearchSettings:', res);
        throw new Error('failed');
      }
    });
  }

  getNicheSearch(): Promise<IApiResponse<any>> {
    return memberSearchApi.getNicheSearch().then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: nicheSearch.mappingObjects(res.data.items),
          };
        }
        console.log('ERROR: memberSearchService/getNicheSearch:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: memberSearchService/getNicheSearch:', res);
        throw new Error('failed');
      }
    });
  }

  getListEntitiesSearch(categoryId: string, params: IParamsRequest): Promise<IApiResponse<any>> {
    return memberSearchApi.getListEntitiesSearch(categoryId, params).then(res => {
      try {
        if (res.success) {
          res.data.items =
            (params &&
              params.isMappingIconObject &&
              properyItemModel.getIconObjects(categoryId, properyItemModel.mappingObjects(res.data.items, categoryId, -99))) ||
            properyItemModel.mappingObjects(res.data.items, categoryId, -99);
          return { success: true, categoryId, data: res.data };
        }
        console.log('ERROR: memberSearchService/getListEntitiesSearch:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: memberSearchService/getListEntitiesSearch:', res);
        throw new Error('failed');
      }
    });
  }

  postUsersMemberSearchProfile(
    params: IParamsRequest,
    isSearchUserName: boolean,
    isSearchActiveNow: boolean,
    isSearchSpotlight = false
  ): Promise<IApiResponse<any>> {
    return memberSearchApi.postUsersMemberSearchProfile(params, isSearchSpotlight).then(res => {
      const searchData = myStore.getStore().getState().memberSearchReducer;
      try {
        if (res.success && res.data.ProfileSummaries) {
          const { ProfileSummaries, SearchGuid, PageSize, PageNumber, SearchRequest } = res.data;
          let data;
          if (isSearchUserName) {
            data = {
              usersSearchUserName: memberProfile.mappingObjectsCustomMemberSearch(ProfileSummaries),
              searchGuid: searchData.searchGuid,
              pageSize: searchData.pageSize,
              pageNumber: searchData.pageNumber,
              userNameSearch: {
                page: PageNumber,
                pageSize: PageSize,
                searchGuid: SearchGuid,
              },
            };
          } else {
            data = {
              users: memberProfile.mappingObjectsCustomMemberSearch(ProfileSummaries),
              searchGuid: SearchGuid,
              pageSize: PageSize,
              pageNumber: PageNumber,
              locationName: SearchRequest && SearchRequest.GoogleMapPlace ? SearchRequest.GoogleMapPlace.LocationName : '',
              isSearchActiveNow,
            };
          }
          return {
            success: true,
            data,
          };
        }
        console.log('ERROR: memberSearchService/postUsersMemberSearchProfile:', res.message);
        let data: { pageSize: number; usersSearchUserName?: any[]; users?: any[] } = { pageSize: params.Size };
        if (isSearchUserName) {
          data.usersSearchUserName = [];
        } else {
          data.users = [];
        }

        return {
          success: true,
          data,
        };
      } catch (e) {
        console.log('ERROR: memberSearchService/postUsersMemberSearchProfile:', res);
        throw new Error('failed');
      }
    });
  }

  postUserMemberSearchAction(id: string, index: number, actionType: string, params: IParamsRequest): Promise<IApiResponse<any>> {
    return memberSearchApi.postUserMemberSearchAction(id, index, actionType, params).then(res => {
      try {
        return {
          success: res.success,
          actionSuccess: res.success,
          data: typeof res.data === 'object' ? userStatus.mappingObject(res.data) : null,
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: memberSearchService/postUserMemberSearchAction:', res);
        throw new Error('failed');
      }
    });
  }

  getUserSavedSearches(): Promise<IApiResponse<any>> {
    return memberSearchApi.postGetUserSavedSearches().then(res => {
      try {
        return {
          success: res.success,
          data: SavedSearches.mappingListData(res.data && Array.isArray(res.data.items) && res.data.items),
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: memberSearchService/getUserSavedSearches:', res);
        throw new Error('failed');
      }
    });
  }

  postUserSavedSearches(params: IParamsRequest): Promise<IApiResponse<any>> {
    return memberSearchApi.postGetUserSavedSearches(params).then(res => {
      try {
        return {
          success: res.success,
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: memberSearchService/postUserSavedSearches:', res);
        throw new Error('failed');
      }
    });
  }

  deleteUserSavedSearches(id: number): Promise<IApiResponse<any>> {
    return memberSearchApi.deleteUserSavedSearches(id).then(res => {
      try {
        return {
          success: res.success,
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: memberSearchService/deleteUserSavedSearches:', res);
        throw new Error('failed');
      }
    });
  }

  getSpotlightMember(params: IParamsRequest): Promise<IApiResponse<any>> {
    return memberSearchApi.getSpotlightMember(params).then(res => {
      try {
        if (res.success && res.data) {
          return {
            success: true,
            data: memberProfile.mappingObjectsCustomMemberSearch(res.data.ProfileSummaries || []),
            hasMoreSpotlight: res.data.ProfileSummaries?.length === params.pageSize,
            pageNumber: res.data.PageNumber,
          };
        }
        console.log('ERROR: userService/getUserMemberSpotlight:', res.message);
        return res;
      } catch (e) {
        console.log('ERROR: userService/getUserMemberSpotlight:', e);
        throw new Error('failed');
      }
    });
  }

  getSpotlightFeatured(): Promise<IApiResponse<IMemberProfile[]>> {
    return memberSearchApi.getSpotLightFeatured().then(res => {
      try {
        if (res.success && res.data) {
          return {
            success: true,
            data: memberProfile.mappingObjectsCustomMemberSearch(res.data.ProfileSummaries || []),
          };
        }
        console.log('ERROR: userService/getSpotlightFeatured:', res.message);
        return res;
      } catch (e) {
        console.log('ERROR: userService/getSpotlightFeatured:', res);
        throw new Error('failed');
      }
    });
  }
}

export default new MemberSearchService();
